/* import __COLOCATED_TEMPLATE__ from './salesforce.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();